module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.entity && _vm.actions.length) ? _c('action-buttons', {
    attrs: {
      "actions": _vm.actions,
      "type": _vm.type
    }
  }) : (_vm.entity) ? _c('div', {
    staticClass: "dropdown-buttons"
  }, [_c('span', [_vm._v("No actions available")])]) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-fb6861bc!./~/vue-loader/lib/template-loader.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/structure/ui/actions/SubscriptionActionButtons.vue
// module id = 2755
// module chunks = 1